/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ApiAppExceptionTestBrokerExceptionGet400Response } from '../model/api-app-exception-test-broker-exception-get400-response.model';
// @ts-ignore
import { BackofficeGroupMemberNotificationSettingsInfoDto } from '../model/backoffice-group-member-notification-settings-info-dto.model';
// @ts-ignore
import { BackofficeGroupMemberNotificationSettingsUpdateDto } from '../model/backoffice-group-member-notification-settings-update-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BackofficeGroupNotificationSettingsApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint delete /api/backoffice-groups/{groupId}/go-users/{goUserId}/notification-settings
     * @param groupId 
     * @param goUserId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsDelete(groupId: string, goUserId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsDelete(groupId: string, goUserId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsDelete(groupId: string, goUserId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsDelete(groupId: string, goUserId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsDelete.');
        }
        if (goUserId === null || goUserId === undefined) {
            throw new Error('Required parameter goUserId was null or undefined when calling apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsDelete.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/backoffice-groups/${this.configuration.encodeParam({name: "groupId", value: groupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/go-users/${this.configuration.encodeParam({name: "goUserId", value: goUserId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/notification-settings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/backoffice-groups/{groupId}/go-users/{goUserId}/notification-settings
     * @param groupId 
     * @param goUserId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsGet(groupId: string, goUserId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BackofficeGroupMemberNotificationSettingsInfoDto>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsGet(groupId: string, goUserId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BackofficeGroupMemberNotificationSettingsInfoDto>>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsGet(groupId: string, goUserId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BackofficeGroupMemberNotificationSettingsInfoDto>>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsGet(groupId: string, goUserId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsGet.');
        }
        if (goUserId === null || goUserId === undefined) {
            throw new Error('Required parameter goUserId was null or undefined when calling apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/backoffice-groups/${this.configuration.encodeParam({name: "groupId", value: groupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/go-users/${this.configuration.encodeParam({name: "goUserId", value: goUserId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/notification-settings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BackofficeGroupMemberNotificationSettingsInfoDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint put /api/backoffice-groups/{groupId}/go-users/{goUserId}/notification-settings
     * @param groupId 
     * @param goUserId 
     * @param backofficeGroupMemberNotificationSettingsUpdateDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsPut(groupId: string, goUserId: string, backofficeGroupMemberNotificationSettingsUpdateDto?: BackofficeGroupMemberNotificationSettingsUpdateDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BackofficeGroupMemberNotificationSettingsInfoDto>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsPut(groupId: string, goUserId: string, backofficeGroupMemberNotificationSettingsUpdateDto?: BackofficeGroupMemberNotificationSettingsUpdateDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BackofficeGroupMemberNotificationSettingsInfoDto>>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsPut(groupId: string, goUserId: string, backofficeGroupMemberNotificationSettingsUpdateDto?: BackofficeGroupMemberNotificationSettingsUpdateDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BackofficeGroupMemberNotificationSettingsInfoDto>>;
    public apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsPut(groupId: string, goUserId: string, backofficeGroupMemberNotificationSettingsUpdateDto?: BackofficeGroupMemberNotificationSettingsUpdateDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsPut.');
        }
        if (goUserId === null || goUserId === undefined) {
            throw new Error('Required parameter goUserId was null or undefined when calling apiBackofficeGroupsGroupIdGoUsersGoUserIdNotificationSettingsPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/backoffice-groups/${this.configuration.encodeParam({name: "groupId", value: groupId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/go-users/${this.configuration.encodeParam({name: "goUserId", value: goUserId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/notification-settings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BackofficeGroupMemberNotificationSettingsInfoDto>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: backofficeGroupMemberNotificationSettingsUpdateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
